<template>
  <div style="height:100%">
    <div id="videos" class="col-12" v-loading="LOADING">
      <div class="row" style="height: 100%;overflow-x: scroll;">
        <div class="col-12">
          <div v-show="!LOADING" v-if="!APPT_REQUESTED" style="margin-bottom: 4rem;">
            <div class="row">
              <div class="col-12 col-lg-6 pb-2">
                <card id="order-med-card" class="mt-2" style="background-color: #cfe8f9;border-radius: 24px;" card-body-classes="pt-0" v-if="settings.patientWellness.fitness.workout.enabled" @click.native="
                  goToTraining()">
                  <h5 slot="header" class="card-title" style="font-weight: 600;color: #fff;filter: drop-shadow(2px 2px 3px grey);">
                    {{ $t("message.Specialized Training") }}
                  </h5>
                  <div class="pb-3" style="color: #fff;width: 16em;">
                  </div>

                  <div slot="footer">
                    <n-button round style="background: #fff; color: grey;font-weight: 600;border-radius: 0.8rem" size="lg" class="mb-2">
                      <i class="fa fa-headset pr-1"></i>
                      {{ $t("message.Train Now") }}
                    </n-button>
                  </div>
                </card>
              </div>

              <div class="col-12 col-lg-6 pb-2">
                <card id="consult-now-card" class="mt-2" style="background-color: #cfe8f9;border-radius: 24px" card-body-classes="pt-0" @click.native="scheduleAppointment" v-if="settings.patientWellness.fitness.liveTraining.enabled">
                  <h5 slot="header" class="card-title" style="color: #fff;filter: drop-shadow(2px 2px 3px grey);font-weight: 600;">
                    {{ $t("message.Live personalised training") }}
                  </h5>
                  <div class="pb-3" style="color: #fff;width: 16em;">
                    {{ $t("message.Get live access to trainers for assistance") }}
                  </div>

                  <div slot="footer">
                    <n-button round style="background: #fff; color: grey;font-weight: 600;border-radius: 0.8rem" size="lg" class="mb-2">
                      <i class="fa fa-headset pr-1"></i>
                      {{ $t("message.Talk to Trainer") }}
                    </n-button>
                  </div>
                </card>
              </div>

              <div class="col-12 col-lg-6 pb-2">
                <card id="blog-card" class="mt-2" style="background-color: #cfe8f9;border-radius: 24px" card-body-classes="pt-0" @click.native="$router.push('/blogfeed?category=Fitness')" v-if="settings.patientWellness.fitness.blog.enabled">
                  <h5 slot="header" class="card-title" style="color: #fff;filter: drop-shadow(2px 2px 3px grey);font-weight: 600;">
                    {{ $t("message.Fitness Blog") }}
                  </h5>
                  <div class="pb-3" style="color: #fff;width: 20em;">
                    {{ $t("message.Get inspired with fitness blogs") }}
                  </div>

                  <div slot="footer">
                    <n-button round style="background: #fff; color: grey;font-weight: 600;border-radius: 0.8rem" size="lg" class="mb-2">
                      <i class="fas fa-book-reader pr-1"></i>
                      {{ $t("message.View Blog") }}
                    </n-button>
                  </div>
                </card>
              </div>

              <div class="col-12 col-lg-6 pb-2">
                <card id="videos-card" class="mt-2" style="background-color: #cfe8f9;border-radius: 24px" card-body-classes="pt-0" @click.native="goToVideos" v-if="settings.patientWellness.fitness.videos.enabled && caregroup">
                  <h5 slot="header" class="card-title" style="color: #fff;filter: drop-shadow(2px 2px 3px grey);font-weight: 600;">
                    {{ $t("message.Fitness Videos") }}
                  </h5>
                  <div class="pb-3" style="color: #fff;width: 20em;">
                    {{ $t("message.Workout videos, workout routines, healthy recipes and more") }}
                  </div>

                  <div slot="footer">
                    <n-button round style="background: #fff; color: grey;font-weight: 600;border-radius: 0.8rem" size="lg" class="mb-2">
                      <i class="fas fa-play pr-1"></i>
                      {{ $t("message.Watch Videos") }}
                    </n-button>
                  </div>
                </card>
              </div>
            </div>
          </div>

          <div v-if="!APPT_REQUESTED && !LOADING" style="top: auto;
                                                      bottom: 0px;
                                                      position: fixed;
                                                      width: 100%;
                                                      left: 0
                                                    ">
          </div>

          <!-- Care Coordinator Disclaimer -->
          <modal :show.sync="SHOW_CARECO_DISCLAIMER" headerclasses="justify-content-center" :showClose="false">
            <h4 slot="header" class="title title-up">
              {{ $t("message.Agree to proceed") }}
            </h4>
            <p>
              {{ $t("message.Please note that this request service allows audio and video information sent to the care coordinator during the session, which may be discoverable in a legal matter By joining this session, you automatically consent to the same If you do not consent, discuss your concerns with the administrator") }}
            </p>
            <template slot="footer">
              <n-button @click.native="SHOW_CARECO_DISCLAIMER = false" round>{{
                $t("message.Disagree")
              }}</n-button>
              <n-button type="primary" round @click.native="requestAppointment()">{{
                $t("message.Agree")
              }}</n-button>
            </template>
          </modal>

          <div v-if="APPT_REQUESTED" class="video-call-wrapper">
            <n-button icon v-if="CARECO_JOINED" style="position: absolute;top: 1em;inset-inline-end: 2em;z-index: 1" round type="danger" size="lg" @click.native="cancelAppointment" class="d-md-none">
              <i class="now-ui-icons ui-1_simple-remove"></i>
            </n-button>

            <vmaatu v-if="CARECO_JOINED &&
              user.endpoint &&
              user.endpoint.videoConfEPType == 'VMAATU_RTC'
            " :query="simpleMeetingsQuery" ref="vmaatu"></vmaatu>
            <webex-teams v-if="CARECO_JOINED &&
              user.endpoint &&
              user.endpoint.videoConfEPType == 'WEBEXTEAMS_GUEST'
            " :query="simpleMeetingsQuery" ref="webex-teams"></webex-teams>

            <div v-if="!CARECO_JOINED" style="
                                                        position: absolute;
                                                        height: 93vh;
                                                        z-index: 1030;
                                                        width: 100%;
                                                        background: #ffffff;
                                                      ">

              <n-button round type="danger" size="lg" @click.native="cancelAppointment" class="d-md-none cancel-appt-request-button" v-if="APPT_REQUESTED" style="position: absolute;
                                                    bottom: 4em;
                                                    inset-inline-end: 50%;
                                                    transform: translateX(50%);">
                {{ $t("message.Cancel Request") }}
              </n-button>
              <img src="@/assets/img/bg2.svg" />
              <div class="col-12 text-center" style="margin-top: 20vh">
                <h6>{{ $t("message.Kindly wait until a Coordinator answers your request") }}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <n-button type="primary" round size="lg" style="font-weight: 600;position: fixed;bottom: 0px;left: 50%;transform: translate(-50%);" @click.native="$store.commit('setState', {
        stateName: 'trainingType',
        stateValue: 'fitness',
      }); $router.push('/fitnessandyogareports');">
        <i class="el-icon-tickets"></i>
        {{ $t("message.View Reports") }}
      </n-button>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  name: "videos",

  components: { Carousel, Slide },

  data() {
    return {
      LOADING: true,
      selectedVideo: null,
      playerVars: {
        autoplay: 0,
        modestbranding: 1,
      },
      SHOW_CARECO_DISCLAIMER: false,
      APPT_REQUESTED: false,
      carouselSlide: 0,
      caregroup: null
    };
  },

  async mounted() {
    this.$root.onBackButton = () => {
      this.$router.push("/patienthome");
    };
    let that = this;
    try {
      let getCaregroups = await this.$store.dispatch("getCaregroups");
      for (let caregroup of getCaregroups.data) {
        if (caregroup.name == "Fitness") {
          this.caregroup = caregroup;
          break;
        }
      }
      this.$store.commit("setState", {
        stateName: "trainingType",
        stateValue: "fitness",
      });
    } catch (e) {
      console.log(e);
    }

    that.LOADING = false;
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
  },
  watch: {
    carouselSlide: function () {
      if (this.$refs.youtubeVideos) {
        for (let video of this.$refs.youtubeVideos) {
          video.player.pauseVideo();
        }
      }
    },
  },

  computed: {
    user() {
      return JSON.parse(localStorage.user);
    },
    player() {
      return this.$refs.youtube.player;
    },
  },
  methods: {
    scheduleAppointment() {
      // this.$router.push("/speciality/63051da9f7d68746ceb4f8d7");
      this.$router.push("/trainerconsult");
    },
    async cancelAppointment() {
      let _that = this;
      swal
        .fire({
          title: this.$t("message.Cancel Appointment"),
          text: this.$t(
            "message.Are you sure that you want to cancel this request?"
          ),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: this.$t("message.Yes, Cancel"),
          cancelButtonText: this.$t("message.No"),
          closeOnConfirm: true,
        })
        .then(async (confirm) => {
          if (confirm.value) {
            await _that.$store.dispatch("updateStatus", {
              appointmentId: _that.appointment._id,
              status: "Cancelled",
            });

            if (this.$refs["webex-teams"]) {
              this.endWebexCall();
            }

            //Update care coordinator on appointment cancel
            socket.emit("appointmentRequestCancelled", {
              careCoordinatorId: _that.appointment.careCoordinator.id,
              appointmentId: _that.appointment._id,
            });
            _that.appointment = null;

            _that.$store.commit("setState", {
              stateName: "appointment",
              stateValue: _that.appointment,
            });

            _that.APPT_REQUESTED = false;
            _that.CARECO_JOINED = false;
            _that.getScheduledAppointments();
          } else {
            swal.close();
          }
        });
    },
    async requestAppointment(appt) {
      let that = this;

      that.SHOW_CARECO_DISCLAIMER = false;
      let loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
      });
      if (this.user.caregroup) {
        try {
          if (appt) {
            this.appointment = appt;
          } else {
            this.appointment = {
              patient: {
                patientId: this.user.patientId,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                gender: this.user.gender,
                dob: this.user.dob,
                history: this.user.history,
              },
              questionnaire: "",
              attendant: {
                firstName: this.user.firstName,
                lastName: this.user.lastName,
              },
              appointmentStatus: [
                {
                  status: "Created",
                  timestamp: new Date().getTime(),
                },
              ],
              latestStatus: "Created",
              createdBy: "patient",
              appointmentType: "Live",
              endpoint: this.user.endpoint.name,
              consultationType: "telemedicine",
              preferredVideoCodec: device.platform == "iOS" ? "h264" : "",
            };

            this.appointment.careCoordinator = {
              caregroupId: this.user.caregroup._id || this.user.caregroup,
            };

            this.appointment = await this.$store.dispatch(
              "requestAppointment",
              this.appointment
            );
          }

          socket.emit(
            "appointmentRequested",
            this.appointment.careCoordinator.caregroupId
          );

          this.$store.commit("setState", {
            stateName: "appointment",
            stateValue: this.appointment,
          });

          //Join this appointment room
          socket.emit("joinRoom", {
            type: "appointment",
            id: this.appointment._id,
            userId: this.user._id,
          });

          this.APPT_REQUESTED = true;

          if (
            !this.user.endpoint ||
            this.user.endpoint.videoConfEPType == "VMAATU_RTC"
          ) {
            // let instance = this.baseUrl
            //   .split("//")[1]
            //   .split(":")[0]
            //   .replace(/\./g, "_");

            //  room_name:
            //     this.instance +
            //     "_" +
            //     (this.appointment.latestStatus == "InProgress"
            //       ? this.baseUrl.split(":")[1].substr(2) + "_"
            //       : "") +
            //     this.appointment._id,

            this.simpleMeetingsQuery = {
              api_key: this.settings.vMaatuSettings.apikey,
              room_name: this.instance + "_" + this.appointment._id,
              user_name: this.user.username,
              tenant_name: this.user.tenant.name,
              controls: "true",
              video_encoding: this.appointment.preferredVideoCodec || "",
            };
          }

          socket.emit("appointmentCreated", {
            careCoordinatorId: this.appointment.careCoordinator.id,
            appointmentId: this.appointment._id,
          });
          loader.hide();
          this.$store.commit("setState", {
            stateName: "SHOW_TITLE_BAR",
            stateValue: false,
          });
          if (!appt) {
            swal.fire({
              title: this.$t("message.Appointment Requested"),
              text: this.$t(
                "message.Your appointment request has been sent to Care coordinator Please wait until his response"
              ),
              type: "success",
              timer: 3000,
              showCloseButton: true,
            });
          }
        } catch (e) {
          loader.hide();
          console.log(e);

          if (
            e.response &&
            e.response.data &&
            e.response.data.message == "No Care Coordinator online"
          ) {
            swal.fire({
              title: this.$t("message.Sorry!"),
              text: this.$t(
                "message.No Care Coordinators available Please try after some time In case of emergency call 1800 564 887"
              ),
              type: "warning",
              showCloseButton: true,
            });
          }
        }
      } else {
        loader.hide();
        swal.fire({
          title: this.$t("message.Sorry!"),
          text: this.$t(
            "message.Could not initiate the appointment Contact Administrator"
          ),
          type: "warning",
          showCloseButton: true,
        });
      }
    },
    showCareCoDisclaimer() {
      this.SHOW_CARECO_DISCLAIMER = true;
    },
    selectVideo(video) {
      this.selectedVideo = video;
      this.$forceUpdate();
    },
    goToTraining(training) {
      this.$store.commit("setState", {
        stateName: "training",
        stateValue: training,
      });
      this.$router.push("/fitnesssets");
    },
    goToVideos() {
      this.$store.commit("setState", {
        stateName: "videos",
        stateValue: this.caregroup.videos,
      });
      this.$router.push({ path: "videos", query: { title: "Fitness Videos" } });
    },
  },
};
</script>

<style scoped>
/deep/ .card {
  height: 100%
}

#consult-now-card {
  background-image: url("../../../assets/img/exercise2.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
}

#blog-card {
  background-image: url("../../../assets/img/blog.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
}

#videos-card {
  background-image: url("../../../assets/img/weightlift.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
}

#order-med-card {
  background-image: url("../../../assets/img/excercise1.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
}

.video-call-wrapper {
  width: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
  inset-inline-end: 0px;
  height: 93vh;
  z-index: 1030;
  background-color: #f1f1f1;
}

#order-med-card {
  background-size: cover;
  background-repeat: no-repeat;
}

/deep/ iframe {
  width: 100%;
  height: 16em;
}

.video-thumbnail {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.playing-video-title {
  font-weight: 600;
  margin-top: 1rem;
}

.videos-list {
  overflow-y: scroll;
  height: 54vh;
}

/deep/.el-loading-spinner {
  position: fixed;
}

/deep/ .el-loading-mask {
  background: #fff !important;
}

@media (min-width: 992px) {
  iframe {
    height: 31em;
  }
}

@media (min-height: 736px) {
  /deep/ iframe {
    height: 35vh;
  }

  .videos-list {
    height: 40vh;
  }
}

@media (min-height: 768px) {
  /deep/ iframe {
    height: 40vh;
  }

  .videos-list {
    height: 40vh;
  }
}

@media (min-height: 1024px) {
  iframe {
    height: 31em;
  }

  .videos-list {
    height: 46vh;
  }
}

/deep/ .VueCarousel-dot-container {
  margin-top: 0px !important;
}

/deep/ .VueCarousel-dot {
  width: 5px !important;
  height: 5px !important;
  margin-top: 0px !important;
}

/deep/ .VueCarousel-dot:focus {
  outline: none !important;
}
</style>
